const initializeFaq = () => {
  const input = document.querySelector('input[placeholder="Pesquisar"]');
  const faqItems = document.querySelectorAll('.faq-item');

  if (!input || !faqItems.length) return;

  // SVG do ícone de menos
  const iconMenos = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" fill="black"/>
      <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="black"/>
      <path d="M5 12.5H19" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  // SVG do ícone de mais
  const iconMais = `
    <svg class="w-[24px] h-[24px] transition-transform duration-300" fill="none">
      <use href="${window.GLOBAL?.context?.sprite || ''}#icon-soma"></use>
    </svg>
  `;

  // Atualiza o ícone da primeira resposta se ela estiver visível
  faqItems.forEach((item, index) => {
    const answer = item.querySelector('.faq-answer');
    const iconContainer = item.querySelector('.icon-faq');

    if (answer.classList.contains('block') || answer.classList.contains('!block')) {
      iconContainer.innerHTML = iconMenos;
    } else {
      iconContainer.innerHTML = iconMais;
    }
  });

  // Filtro de busca
  input.addEventListener('input', (e) => {
    const value = e.target.value.toLowerCase();
    faqItems.forEach((item) => {
      const question = item.querySelector('p');
      const text = question.textContent.toLowerCase();
      item.classList.toggle('hidden', !text.includes(value));
    });
  });

  // Expandir/colapsar
  faqItems.forEach((item) => {
    const toggle = item.querySelector('.toggle-faq');
    const answer = item.querySelector('.faq-answer');
    const iconContainer = item.querySelector('.icon-faq');

    toggle.addEventListener('click', () => {
      const isOpen = answer.classList.contains('block');

      // Fecha todos
      faqItems.forEach((el) => {
        el.querySelector('.faq-answer').classList.remove('block');
        el.querySelector('.faq-answer').classList.add('hidden');
        el.querySelector('.icon-faq').innerHTML = iconMais;
      });

      // Abre o atual se estava fechado
      if (!isOpen) {
        answer.classList.remove('hidden');
        answer.classList.add('block');
        iconContainer.innerHTML = iconMenos;
      }
    });
  });
};

export default initializeFaq;

